import Constants from '../utils/Constants';

export const hr: Locale.Keys = {
  lang: Constants.lang.hr,
  menu: {
    ourStory: 'NAŠA PRIČA',
    roomsSuites: 'SOBE & APARTMANI',
    stayingCora: 'OTKRIJTE BEZVREMENSKI ŠARM',
    coraCaffe: 'CORA CAFFE',
    spa: 'WELLNESS & SPA',
    meetingsEvents: 'KONFERENCIJE & DOGAĐANJA - Busy Cora',
    offers: 'POSEBNE PONUDE',
    gallery: 'GALERIJA',
    contactUs: 'KONTAKTIRAJTE NAS',
    bookNow: 'REZERVIRAJ',
  },
  about: {
    title: 'Dobrodošli u Cora Hotel',
    p1: 'Cora, intimni hotel s 34 sobe, sofisticiran je spoj udobnosti i urbane dinamike. Smješten u mirnom dijelu grada udaljenom samo nekoliko minuta vožnje od centra, Cora je nadomak svega što želite vidjeti i doživjeti u drevnom Splitu.',
    p2: 'Izgrađen 1973. godine, hotelski objekt je prošao kroz temeljitu renovaciju i nudi vam elegantni, topli i ugodni ambijent. S ciljem stvaranja ugođaja koji podiže iskustvo boravka na višu razinu, personalizirana usluga i zadovoljstvo gostiju glavni su prioriteti našeg gostoljubivog osoblja.',
  },
  services: {
    title: 'SADRŽAJ I USLUGE',
    frontDesk: 'RECEPCIJA 24/7',
    breakfast: 'RASKOŠAN DORUČAK',
    rooftop: 'ROOFTOP BAR',
    spa: 'WELLNESS & SPA',
    gym: 'TERETANA',
    conference: 'KONFERENCIJSKA SALA',
    wheelchair: 'PRISTUP ZA OSOBE S INVALIDITETOM',
    pet: 'KUĆNI LJUBIMCI SU DOBRODOŠLI',
    parking: 'PARKING',
    eCharging: 'PUNIONICA ZA ELEKTRIČNE AUTOMOBILE',
  },
  roomsAndSuites: {
    title: 'SOBE I APARTMANI',
    subtitle: 'VAŠA PRIVATNA OAZA LUKSUZA',
    p1: 'Svaka soba i apartman nudi profinjenu, rezidencijalnu atmosferu upotpunjenu najnovijom tehnologijom, udobnim namještajem i izuzetnom pažnjom posvećenom detaljima.',
    comfortTitle: 'Standard',
    comfort: 'Standardna Soba',
    superiorCourtyardTitle: 'Superiror I',
    superiorCourtyard: 'Superior Dvokrevetna Soba s Pogledom na Dvorište',
    superiorStreetTitle: 'Superior II',
    superiorStreet: 'Superior Dvokrevetna Soba s Pogledom na Gradsku Ulicu',
    suiteTitle: 'Apartmani',
    suite: 'Junior Apartman',
    showMore: 'POKAŽI VIŠE',
  },
  comfortRoom: {
    title: 'STANDARDNA SOBA',
    subtitle: 'standard',
    p1: 'Ukusno namještene s intimnim, elegantnim ugođajem, sobe u Cori su idealna baza za istraživanje živahnog susjedstva.',
  },
  superiorCourtyard: {
    title: 'SUPERIOR DVOKREVETNA SOBA S POGLEDOM NA DVORIŠTE',
    subtitle: 'superior I',
    p1: 'Ukusno namještene s intimnim, elegantnim ugođajem, sobe u Cori su idealna baza za istraživanje živahnog susjedstva.',
  },
  superiorStreet: {
    title: 'SUPERIOR DVOKREVETNA SOBA S POGLEDOM NA GRADSKU ULICU',
    subtitle: 'superior II',
    p1: 'Ukusno namještene s intimnim, elegantnim ugođajem, sobe u Cori su idealna baza za istraživanje živahnog susjedstva.',
  },
  juniorSuite: {
    title: 'JUNIOR APARTMAN',
    subtitle: 'apartmani',
    p1: 'Nježne boje i pažljivo osmišljeni detalji upotpunjuju dojam modernog luksuza u svijetlim ,prozračnim apartmanima.',
  },
  stayingAtCora: {
    title: 'OTKRIJTE BEZVREMENSKI ŠARM',
    restaurantTitle: 'GASTRONOMIJA',
    restaurant:
      '...udobno se smjestite u Delicious Cora suvremenom restoranu s elegantnim interijerom i jelima nadahnutim bogatom raznolikošću svježih, lokalnih mediteranskih proizvoda.\n\nDORUČAK\nod 06:30 do 10:30 h\n\nAutentičnost i izuzetni okusi glavna su obilježja prepoznatljivih regionalnih jela koja su sastavni dio našeg raskošnog doručka, zajedno sa nizom specijaliteta i okusa iz cijeloga svijeta.',
    spaTitle: 'WELLNESS & SPA',
    spa: '...hotelski spa predstavlja mirni, opuštajući prostor sa sobama za tretmane, hidromasažnom kadom, saunom i malom teretanom.',
    conferenceTitle: 'KONFERENCIJSKA DVORANA',
    conference:
      '...idealna za sastanke, manje konferencije ili elegantna privatna okupljanja, konferencijska sala nudi okruženje i uslugu koja osigurava da svaki događaj ostane nezaboravan.',
    rooftopTitle: 'CORA CAFFE',
    rooftop:
      '…hotelski Rooftop bar, do kojega se dolazi panoramskim dizalom, najšarmantnija je značajka hotela. Uživajte u raznolikoj ponudi napitaka, pića s potpisom i pogledu koji se proteže na obližnje planine s jedne strane i živahno susjedstvo s druge.',
  },
  coraCaffe: {
    title: 'CORA CAFFE ROOFTOP BAR',
    subtitle: 'CORA CAFFE',
    p1: 'Hotelski Rooftop bar, do kojega se dolazi panoramskim dizalom, najšarmantnija je značajka hotela. Uživajte u raznolikoj ponudi napitaka, pića s potpisom i pogledu koji se proteže na obližnje planine s jedne strane i živahno susjedstvo s druge.',
    ul1: 'LJetno radno vrijeme:',
    li1: 'Ponedjeljak - Nedjelja',
    p2: 'Besplatan parking 2 sata za goste Cora Caffe Rooftop Bara',
    p3: 'Cora Caffe Meni',
    offHoursMessage: {
      header: 'Dragi gosti,',
      p1: 'Tijekom zimske sezone Cora Caffe rooftop bar je privremeno zatvoren.',
      p2: 'Rado ćemo Vas ugostiti u našem baru u prizemlju Cora hotela.',
      footer: 'Cora team',
    },
  },
  spa: {
    title: 'OPUSTITE SE I POMLADITE',
    subtitle: 'WELLNESS & SPA',
    button: 'POGLEDAJ MENI',
    p1: 'Uživajte u luksuzu naše mirne spa oaze dok se prepuštate našem nizu umirujućih spa tretmana. Dopustite stručnim rukama naših terapeuta da vas vode kroz putovanje opuštanja, omogućujući vam da pomladite ne samo svoje tijelo već i svoj um i dušu.',
    p2: 'Wellness sadržaji za goste hotela (finska sauna, jacuzzi) prema rezervaciji i radnom vremenu. Potrebna rezervacija minimalno 45min prije tretmana. Molimo da unaprijed kontaktirate naše osoblje na racepciji ako želite koristiti wellness sadržaje izvan radnog vremena.',
    p3: 'Cijene su izražene u hrvatskoj valuti kunama i eurima prema fiksnom tečaju 1EUR = 7,53450HRK (zaokruženo na 2 decimalna mjesta) definirano Uredbom Vijeća (EU) 2022/1208 od 12. srpnja 2022.',
    massage: {
      title: 'Masaže',
      body: {
        title: 'Rituali za tijelo',
        subtitle: '',
      },
      muscle: {
        title: 'Distres masaža mišića',
        subtitle:
          'Ovo su usluge osmišljene za poticanje cjelokupnog zdravlja i smanjenja stresa, napetosti i bolova u mišićima.',
      },
      cora: {
        title: 'Cora Masaža',
        subtitle:
          'Relaksirajuća masaža koja koristi ulja za poticanje opuštanja i ravnoteže u tijelu i umu.',
      },
      additional: {
        title: 'Dodatna usluga masaže',
        l1: 'Masaža lica',
        l2: 'Masaža stopala',
        l3: 'Masaža vlasišta',
      },
    },
    bodyritual: {
      title: 'RITUAL TIJELA',
      mediterranean: {
        title: 'Mediteranski ritual',
        subtitle:
          'Povucite se uz opuštanje pilingom i jedinstvenom tehnikom masaže, baš poput mediteranskog stila života.',
      },
      detox: {
        title: 'Ritual detoksikacije',
        subtitle:
          'Očistite i pročistite svoje tijelo tretmanom detoksikacije. Posebno blato ili glina, morska sol i vitamini izvlače toksine i vraćaju ravnotežu vašoj koži. Nakon svega toga uslijedila je masaža cijelog tijela.',
      },
      scrub: {
        title: 'Piling za tijelo',
        subtitle:
          'Piling će nježno ukloniti mrtve stanice kože, potaknuti regeneraciju novih stanica i savršeno pripremiti kožu.',
      },
    },
    facial: {
      title: 'LICA',
      retreat: {
        title: 'Retreat tretman lica ultrazvučnom lopaticom',
        subtitle:
          'Cora luksuzna njega lica jedinstveni je tretman za njegu lica koji obično uključuje niz koraka osmišljenih za dubinsko čišćenje i piling kože ultrazvučnom špatulom. Također, hidratizira i pomlađuje kožu s učinkom liftinga i jača kožu.',
      },
      exceptional: {
        title: 'Izvanredna njega lica',
        subtitle:
          'Morski "lifting" tretman koji redefinira konture lica i vraća gustoću kože zahvaljujući kombinaciji patentiranog kompleksa morskog obnavljanja i ekskluzivne Energilift tehnike masaže.',
      },
      silicium: {
        title: 'Silikon za lice',
        subtitle:
          'Ovaj anti-aging tretman inspiriran je fitnesom za lice i kombinira ekskluzivnu tehniku masaže s profesionalnom cryo-učvršćujućom dvostrukom maskom za učvršćivanje kože, popunjavanje bora i osvježenje tena u samo 60 minuta.',
      },
      hyalu: {
        title: 'Hyalu-procollagene tretman lica',
        subtitle:
          'Tretman od bora do bora koji kombinira hijaluronsku kiselinu i morski pro-kolagen s Roller Boosterom. Trenutačno lice izgleda mlađe, kao opušteno, a čak i uočene bore izgledaju izglađene.',
      },
      energizing: {
        title: 'Energiziranje lica',
        subtitle:
          'Morska fotografija za urbanu kožu! Detoksikacijski tretman za osvježenje lica, vraćanje svježeg tena i glatke kože.',
      },
      hydra: {
        title: 'Hydra tretman lica',
        subtitle:
          'Thalgova prepoznatljiva njega lica inspirirana morem koncentrira dobrobiti oceana kako bi pomogla obnoviti savršenu kvalitetu kože, pružajući intenzivnu i dugotrajnu hidrataciju.',
      },
      beauty: {
        title: 'Radost ljepote',
        subtitle:
          'Ovi tretmani izvrsni su za sve tipove kože i otkrit će zdraviji i blistaviji ten kože.',
      },
      additional: {
        title: 'Dodatna usluga njege lica',
        l1: 'Masaža vlasišta',
        l2: 'Ultrazvučna lopatica',
      },
    },
    wax: {
      title: 'Depilacija',
      face: {
        title: 'Lice i obrve',
        l1: 'Usne',
        l2: 'Brada',
        l3: 'Oblikovanje obrva',
        l4: 'Boja za obrve',
      },
      bikini: {
        title: 'Bikini',
        l2: 'Bikini',
        l1: 'Brazilka',
      },
      body: {
        title: 'Tijelo',
        l1: 'Ispod pazuha',
        l2: 'Pola ruke',
        l3: 'Pola noge',
        l4: 'Cijela ruka',
        l5: 'Cijela noga',
        l6: 'Leđa ili prsa',
      },
    },
    treatments: {
      title: 'Tretmani',
      pedicure: {
        title: 'Manikura / Pedicura',
        l1: 'Manikura',
        l2: 'Spa manikura',
        l3: 'Pedikura',
        l4: 'Spa pedikura',
      },
      additional: {
        title: 'Dodatna usluga',
        l1: 'CND Shellac',
        l2: 'Soak-off Uklanjanje',
        l3: 'Lak za nokte',
        l4: 'Uklanjanje gela/dippinga/akrila',
      },
    },
  },
  gallery: {
    title: 'GALERIJA',
  },
  amenities: {
    entertainment: {
      title: 'ZABAVA',
      tv: 'Smart TV s kabelskim/satelitskim programom',
    },
    bedFeatures: {
      title: 'KREVET',
      sheets: 'Visokokvalitetna posteljina',
      pillow: 'Hipoalergenski jastuk',
      pillowMenu: 'Izbor jastuka',
      service: 'Turndown usluga',
    },
    bath: {
      title: 'KUPAONICA',
      shower: 'Kupaonica s tuš-kabinom',
      hairdryer: 'Sušilo za kosu',
      cosmetic: 'Kozmetički asortiman',
      scale: 'Vaga',
      amenities: 'Sadržaji za duži boravak (na zahtjev)',
      heating: 'Podno grijanje u kupaonici',
    },
    office: {
      title: 'URED/TELEKOM',
      telephone: 'Telefon',
      wifi: 'Besplatni pristup bežičnom Internetu velike brzine',
      wakeUp: 'Buđenje (na zahtjev)',
      elePlug: 'Univerzalni električni priključak (na zahtjev)',
    },
    dining: {
      title: 'HRANA/PIĆE',
      wine: 'Boca vina dobrodošlice',
      minibar: 'Rashlađeni minibar',
      kettle: 'Kuhalo za kavu i čaj',
    },
    features: {
      title: 'ZNAČAJKE',
      smoke: 'Sobe za nepušače',
      ac: 'Klimatizacija',
      desk: 'Pisaći stol',
      light: 'Svjetlo za čitanje',
      safe: 'Elektronski sef (laptop „friendly“)',
      bathrobe: 'Ogrtač i papuče',
      laundry: 'Vreća za rublje',
    },
    additional: {
      title: 'DODATNE USLUGE',
      beach: 'Artikli za plažu (na zahtjev)',
      crib: 'Dječji krevetić (na zahtjev)',
      gifts: 'Dar dobrodošlice za dijete (informacije dostupne na recepciji)',
      pets: 'Usluge za kućne ljubimce (na zahtjev)',
    },
  },
  impressum: {
    country: 'Hrvatska',
    propName: 'Ime objekta',
    propAddress: 'Adresa objekta',
    compName: 'Ime kompanije',
    compAddress: 'adresa kompanije',
    vat: 'Pdv',
    commercialCourt: {
      title: 'Trgovački sud',
      p1: 'Tvrtka je upisana u sudski registar kod Trgovačkog suda u Splitu pod brojem 060086339.',
    },
    phone: 'Telefon',
  },
  privacyPolicy: {
    title: 'Izjava o zaštiti osobnih podataka',
    introduction: {
      title: 'Uvod i podaci o Voditelju obrade',
      text: 'Ova Izjava o zaštiti osobnih podataka odnosi se na društvo MANAS d.o.o., 21000 Split, Barakovićeva 18, OIB: 77290534017, PDV ID: HR77290534017 (u daljnjem tekstu: Cora Hotel). Cora Hotel, 21000 Split, Put Supavla 29, obrađuje Vaše osobne podatke u skladu s Općom uredbom o zaštiti podataka (EU) 2016/679 (GDPR) te Zakonom o provedbi Opće uredbe o zaštiti podataka (Narodne novine broj 42/2018). Svi podaci zaštićeni su odgovarajućim tehničkim i sigurnosnim mjerama od neovlaštenog pristupa, zlouporabe, gubitka ili uništenja.',
    },
    sections: [
      {
        title: '1. Opće informacije i rokovi za postupanje',
        blocks: [
          {
            type: 'paragraph',
            text: 'Ova Izjava na jasan i sažet način opisuje koje podatke prikupljamo, kako ih obrađujemo, u koje svrhe, kao i Vaša prava vezana uz Vaše podatke.',
          },
          {
            type: 'list',
            items: [
              { text: 'Voditelj obrade: Cora Hotel (MANAS d.o.o.)' },
              { text: 'E-mail za kontakt: voditelj.obrade@manas.hr' },
              { text: 'Telefon: +385 (0) 21 644 200' },
              {
                text: 'Službenik za zaštitu podataka: voditelj.obrade@manas.hr',
              },
            ],
          },
          {
            type: 'paragraph',
            text: 'Voditelj obrade pruža ispitaniku informacije o poduzetim radnjama na temelju zahtjeva bez odgađanja, a u svakom slučaju najkasnije u roku od mjesec dana od primitka zahtjeva. Taj se rok prema potrebi može produžiti za dodatna dva mjeseca, uzimajući u obzir složenost i broj zahtjeva, o čemu će ispitanik biti pravodobno obaviješten. Svi sporovi rješavaju se pred stvarno nadležnim sudom u Splitu.',
          },
        ],
      },
      {
        title: '2. Vrste osobnih podataka koje obrađujemo',
        blocks: [
          {
            type: 'paragraph',
            text: 'Radi maksimalne preglednosti i transparentnosti, Cora Hotel prikuplja i obrađuje isključivo one podatke koji su nužni za poslovanje, komunikaciju i pružanje ugovorenih usluga:',
          },
          {
            type: 'list',
            items: [
              {
                text: 'Kontakt forme i upiti na web stranici: Ime, prezime, e-mail adresa i broj telefona.',
              },
              {
                text: 'Rezervacija smještaja i prijava gostiju: Ime, prezime, adresa prebivališta, e-mail adresa, broj telefona te svi podaci nužni za izvršenje ugovorenih ugostiteljskih usluga i zakonsku prijavu u nacionalni sustav eVisitor. (Napomena: Ne prikupljaju se podaci o privatnim adresama ili osobnim dokumentima ovlaštenih predstavnika ili vlasnika pravnih osoba).',
              },
              {
                text: 'Poslovna suradnja: Ime, prezime, poslovna e-mail adresa, telefonski broj i poslovna pozicija zaposlenika ili ovlaštenih osoba naših poslovnih partnera i dobavljača.',
              },
              {
                text: 'Naknadna naplata: Podaci o kreditnoj kartici za proizvode ili usluge koje gost nije prijavio ili platio prilikom odlaska iz hotela.',
              },
            ],
          },
        ],
      },
      {
        title: '3. Podaci o zdravlju i wellness tretmanima',
        blocks: [
          {
            type: 'paragraph',
            text: 'Obrada osobnih podataka koji se odnose na Vaše zdravstveno stanje, a koji se prikupljaju u svrhu pružanja adekvatnog wellness tretmana, prevencije mogućih ozljeda i osiguranja sigurnosti korisnika, provodi se isključivo na temelju Vaše izričite privole sukladno članku 9. stavku 2. točki (a) GDPR-a. Privola se daje dobrovoljno prije samog tretmana i može se povući u svakom trenutku, bez utjecaja na zakonitost obrade prije povlačenja. Ovi podaci se ne mogu i ne smiju obrađivati na temelju legitimnog interesa.',
          },
        ],
      },
      {
        title: '4. Sustav video nadzora',
        blocks: [
          {
            type: 'paragraph',
            text: 'Hotel Cora koristi sustav video nadzora u svrhu zaštite osoba i imovine te sprječavanja protupravnih radnji na lokacijama hotela, što predstavlja naš legitimni interes sukladno članku 6. stavku 1. točki (f) GDPR-a te člancima 25. – 31. Zakona o provedbi Opće uredbe o zaštiti podataka.',
          },
          {
            type: 'list',
            items: [
              {
                text: 'Rok pohrane: Snimke se pohranjuju i čuvaju najviše 30 dana od dana nastanka, nakon čega se automatski brišu, osim ako su u pojedinačnom slučaju potrebne kao dokazni materijal u pravnim, policijskim ili sudskim postupcima.',
              },
              {
                text: 'Prava ispitanika: Ispitanici imaju pravo zatražiti pristup snimkama video nadzora ako se na njima nalaze, pod uvjetom da to ne ugrožava privatnost trećih osoba.',
              },
            ],
          },
        ],
      },
      {
        title: '5. Pravni temelji obrade podataka',
        blocks: [
          {
            type: 'paragraph',
            text: 'Sve vrste Vaših osobnih podataka obrađuju se isključivo na temelju sljedećih zakonskih osnova:',
          },
          {
            type: 'list',
            items: [
              {
                text: 'a) Ispunjavanje pravnih obveza (Čl. 6.1.c): Obrada je nužna radi usklađivanja sa zakonskim propisima Republike Hrvatske (ugostiteljski, porezni i računovodstveni propisi, eVisitor).',
              },
              {
                text: 'b) Izvršenje ugovora (Čl. 6.1.b): Obrada je nužna za realizaciju rezervacije smještaja, pružanje usluga ili ispunjenje ugovora o poslovnoj suradnji.',
              },
              {
                text: 'c) Izričita privola (Čl. 6.1.a / Čl. 9.2.a): Za potrebe slanja newslettera, marketinških aktivnosti ili obrade zdravstvenih podataka u wellness centru.',
              },
              {
                text: 'd) Legitimni interes (Čl. 6.1.f): Za potrebe rada sustava video nadzora (sigurnost) te osiguranja naknadne naplate neprijavljenih usluga putem kreditne kartice.',
              },
            ],
          },
        ],
      },
      {
        title: '6. Rokovi pohrane podataka',
        blocks: [
          {
            type: 'paragraph',
            text: 'U skladu s načelom ograničenja pohrane, Vaše osobne podatke čuvamo samo onoliko dugo koliko je potrebno za ispunjenje svrha za koje su prikupljeni ili koliko nalažu važeći zakonski propisi:',
          },
          {
            type: 'list',
            items: [
              {
                text: 'Podaci o fakturiranju i financijske transakcije: Čuvaju se 11 godina sukladno Zakonu o računovodstvu.',
              },
              {
                text: 'Podaci iz knjige gostiju i prijave u eVisitor: Čuvaju se trajno sukladno Zakonu o ugostiteljskoj djelatnosti.',
              },
              {
                text: 'Podaci iz kontakt formi i e-mail upita: Brišu se nakon potpunog rješenja Vašeg upita, a najkasnije u roku od 6 mjeseci, osim ako ne dođe do realizacije rezervacije.',
              },
              {
                text: 'Snimke video nadzora: Prepisuju se i brišu automatski nakon najviše 30 dana.',
              },
            ],
          },
        ],
      },
      {
        title: '7. Prava ispitanika',
        blocks: [
          {
            type: 'paragraph',
            text: 'Kao ispitanik imate sljedeća prava koja možete ostvariti u svakom trenutku slanjem zahtjeva na e-mail adresu voditelj.obrade@manas.hr:',
          },
          {
            type: 'list',
            items: [
              {
                text: 'a) Pravo na pristup: Pravo na potvrdu o obradi, informiranje o svrsi obrade te dobivanje kopije svih Vaših osobnih podataka koji se obrađuju.',
              },
              {
                text: 'b) Pravo na ispravak: Pravo na hitnu dopunu ili ispravak nepotpunih ili netočnih podataka.',
              },
              {
                text: 'c) Pravo na brisanje ("pravo na zaborav"): Pravo na brisanje podataka ako više nisu nužni za svrhu obrade ili ako povučete privolu, osim ako zakonski propisi nalažu drukčije.',
              },
              {
                text: 'd) Pravo na ograničenje obrade: U slučajevima kada osporavate točnost podataka ili je obrada nezakonita, ali se protivite brisanju.',
              },
              {
                text: 'e) Pravo na prigovor: Pravo na prigovor protiv obrade koja se temelji na legitimnom interesu.',
              },
              {
                text: 'f) Pravo na prenosivost podataka: Pravo na dobivanje podataka u strukturiranom, uobičajenom i strojno čitljivom formatu.',
              },
              {
                text: 'g) Pravo na podnošenje prigovora nadzornom tijelu: Ako smatrate da su Vaša prava prekršena, imate pravo podnijeti prigovor izravno nacionalnom nadzornom tijelu:',
                details: [
                  'Agencija za zaštitu osobnih podataka (AZOP)',
                  'Sironićeva 15, 10000 Zagreb, Hrvatska',
                  'Web: www.azop.hr | E-mail: azop@azop.hr | Tel: +385 (0)1 4609 000',
                ],
              },
            ],
          },
        ],
      },
      {
        title:
          '8. Povezane vanjske platforme za rezervaciju i prijenos trećim stranama',
        blocks: [
          {
            type: 'paragraph',
            text: 'Prilikom online rezervacije smještaja koristimo integriranu vanjsku platformu Directbook. Navedena platforma djeluje kao izvršitelji obrade u naše ime. Vaši osobni podaci (ime, kontakt podaci, detalji o kartici) prenose se ovoj platformi isključivo u svrhu realizacije i potvrde rezervacije, a sukladno potpisanim Ugovorima o obradi podataka (DPA) prema članku 28. GDPR-a. Podaci se također mogu proslijediti nadležnim državnim tijelima (MUP, Porezna uprava) isključivo na temelju zakonske obveze.',
          },
        ],
      },
    ],
  },
  footer: {
    smsInvoice: 'SMS Parking račun',
  },
  evPaymentRedirect: {
    chargerLabel: 'Punionica / EV charger',
    redirectingTitle: 'Preusmjeravanje na placanje / Redirecting to payment',
    unavailableTitle:
      'Placanje trenutno nije dostupno / Payment is currently unavailable',
    loadingMessage:
      'Molimo pricekajte dok otvaramo stranicu za placanje. / Please wait while we open the payment page.',
    contactReception:
      'Molimo obratite se recepciji za pomoc. / Please contact reception for assistance.',
    configError:
      'Konfiguracija placanja nije dostupna. / Payment configuration could not be loaded.',
    homeLink: 'Cora Hotel',
  },
};
